/* eslint-disable max-len */
/* eslint-disable no-empty */
/* eslint-disable no-unused-vars */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
import { useCallback, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useLocation } from 'react-router-dom';
import Center from '../../assets/styles/Center';
import FormContainer from '../../assets/styles/FormContainer';
import Text from '../../assets/styles/Text';
import FormAuth from '../../components/FormAuth';
import GroupCheck from '../../components/GroupCheck';
import GroupInput from '../../components/GroupInput';
import Loader from '../../components/Loader';
import Title from '../../components/Title';
import AvailabilitiesService from '../../services/AvailabilitiesService';
import LanguagesService from '../../services/LanguagesService';
import ModelService from '../../services/ModelService';
import ValuesService from '../../services/ValuesService';
import { useStore } from '../../stores';

export default function ModelValue() {
  const [availabilities, setAvailabilities] = useState([]);
  const [values, setValues] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [checkAllDays, setCheckAllDays] = useState(false);
  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [inputs, setInputs] = useState({});
  const [cache, setCache] = useState(false);
  const [location, setLocation] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(true);

  const { hash } = useLocation();
  const user = useStore((state) => state.user);

  function onlyNumbers(value) {
    return String(value || '').replace(/\D/g, '');
  }

  const formatTime = useCallback((value) => {
    const numeric = onlyNumbers(value).slice(0, 4);
    if (numeric.length >= 3) {
      return `${numeric.slice(0, 2)}:${numeric.slice(2)}`;
    }
    return numeric;
  }, []);

  function formatValue(value) {
    const formatted = onlyNumbers(value).slice(0, 5);
    return `R$ ${formatted}`;
  }

  useEffect(() => {
    async function loadInputForms() {
      try {
        setLoading(true);
        const valuesService = await ValuesService.listValues();
        const availabilitiesService =
          await AvailabilitiesService.listAvailabilities();
        const languagesService = await LanguagesService.listLanguages();
        const modelGet = await ModelService.modelGetWord(user?.id);

        setValues(valuesService);
        setAvailabilities(availabilitiesService);
        setLanguages(languagesService);
        console.log(modelGet);
        setCache(modelGet.cache);
        setLocation(modelGet.location);

        const languagesModelService = await LanguagesService.listLanguagesModel(
          user.id
        );
        const availabilitiesModelService =
          await AvailabilitiesService.listModelAvailabilities(user.id);

        const valuesModelService = await ValuesService.listModelValues(user.id);

        const parsedInputs = {};

        // valores personalizados
        for (const item of valuesModelService) {
          parsedInputs[`${item.valueId}/value`] = {
            price: `R$ ${item.customRate}`,
          };
        }

        // disponibilidades
        for (const item of availabilitiesModelService) {
          parsedInputs[`${item.availabilityId}/availability`] = {
            start: formatTime(item.startTime),
            end: formatTime(item.endTime),
          };
        }

        // idiomas selecionados
        const parsedLanguages = languagesModelService.map((lang) => ({
          selected: lang.language?.name || '',
          id: lang.languageId,
        }));

        setInputs(parsedInputs);
        setSelectedLanguages(parsedLanguages);

        // Carregar valores existentes de cache e location se existirem
        // Assumindo que existe um serviço para buscar essas informações do modelo
        try {
          // Aqui você pode fazer uma chamada para buscar os valores existentes
          // const modelData = await SomeService.getModelData(user.id);
          // setCache(modelData.cache || false);
          // setLocation(modelData.location || false);
        } catch (error) {
          // Se não existir ou der erro, manter valores padrão (false)
        }
      } catch (error) {
        console.log(error);
        toast.error('Erro ao carregar informações');
      } finally {
        setLoading(false);
      }
    }

    loadInputForms();
  }, [user, formatTime]);

  function handleChangeInputs(dayId, field, value, type) {
    setInputs((prev) => {
      const key = `${dayId}/${type}`;

      const formattedValue =
        type === 'availability' ? formatTime(value) : formatValue(value);

      return {
        ...prev,
        [key]: {
          ...prev[key],
          [field]: formattedValue,
        },
      };
    });
  }

  function handleAddLanguage(e) {
    const [selected, id] = e.target.value.split('/');

    if (!selectedLanguages.find((lang) => lang.selected === selected)) {
      setSelectedLanguages((prev) => [...prev, { selected, id }]);
    }
  }

  async function handleRemoveLanguage(language) {
    try {
      setSelectedLanguages((prev) =>
        prev.filter((lang) => lang.selected !== language.selected)
      );
      await LanguagesService.deleteModelLanguages(language.id);
    } catch {}
  }

  function allDays(stay) {
    if (stay) {
      availabilities.forEach((avlt) => {
        handleChangeInputs(avlt.id, 'end', '23:59', 'availability');
        handleChangeInputs(avlt.id, 'start', '00:00', 'availability');
      });
    } else {
      availabilities.forEach((avlt) => {
        handleChangeInputs(avlt.id, 'end', null, 'availability');
        handleChangeInputs(avlt.id, 'start', null, 'availability');
      });
    }
  }

  function handleStayConnected(e) {
    setCheckAllDays(e.target.checked);
    allDays(e.target.checked);
  }

  function handleCacheChange(e) {
    setCache(e.target.checked);
  }

  function handleLocationChange(e) {
    setLocation(e.target.checked);
  }

  const meta = Object.entries(inputs)
    .map(([key, value]) => {
      const [id, type] = key.split('/');
      const price = onlyNumbers(value?.price);
      const start = onlyNumbers(value?.start);
      const end = onlyNumbers(value?.end);
      if (price?.trim()) {
        return {
          id,
          type,
          price,
        };
      }
      if (start && end) {
        return {
          id,
          type,
          start,
          end,
        };
      }

      return null;
    })
    .filter(Boolean);

  async function onSubmit() {
    try {
      setIsLoading(true);
      if (!meta || meta.length === 0) {
        throw new Error('Está vazio');
      }

      for (const { id, type, price, start, end } of meta) {
        if (type === 'value') {
          const body = {
            valueId: id,
            customRate: Number(price),
          };

          await ValuesService.upsertModelValues(body);
        }

        if (type === 'availability') {
          await AvailabilitiesService.upsertModelAvailabilities({
            availabilityId: id,
            startTime: start,
            endTime: end,
          });
        }
      }

      const selectedIds = selectedLanguages
        .filter((item) => item.selected)
        .map((item) => item.id);

      for (const language of languages) {
        if (selectedIds.includes(language.id)) {
          const data = {
            languageId: language.id,
          };

          await LanguagesService.upsertModelLanguages(data);
        }
      }

      // Enviar cache e location
      const additionalData = {
        cache,
        location,
      };

      await ModelService.modelWord(additionalData);

      // Usa window.location.href para garantir navegação completa
      window.location.href = '/modeldashboard';
    } catch (error) {
      console.log(error);
      toast.error('Erro ao atualizar dados!');
    } finally {
      setIsLoading(false);
    }
  }

  const isFormValid = Boolean(meta?.length);

  if (loading) return <Loader isLoading={loading} />;

  return (
    <FormContainer>
      <Center className="center">
        <Title
          title="Informe seus valores"
          subtitle="Adicione seus hórarios, valores e idiomas"
        />

        <FormAuth
          buttonTitle="Continuar"
          next
          twoButtons
          isLoading={isLoading}
          onSubmit={onSubmit}
          formValid={isFormValid}
        >
          <GroupInput>
            <label>Valores</label>
            {values &&
              values.map((vls) => (
                <div key={vls.id} className="group-value">
                  <Text.Span $bold>{vls.name}</Text.Span>
                  <input
                    type="text"
                    placeholder="Valor"
                    value={inputs[`${vls.id}/value`]?.price || ''}
                    onChange={(e) =>
                      handleChangeInputs(
                        vls.id,
                        'price',
                        e.target.value,
                        'value'
                      )
                    }
                  />
                </div>
              ))}
          </GroupInput>

          <GroupInput>
            <label>Disponibilidade</label>
            <GroupCheck check={checkAllDays}>
              <input
                type="checkbox"
                checked={checkAllDays}
                onChange={handleStayConnected}
              />
              <Text.Span>Todos os dias</Text.Span>
            </GroupCheck>
            {availabilities &&
              availabilities.map((avlt) => (
                <div key={avlt.id} className="group-value">
                  <Text.Span $bold>{avlt.name}</Text.Span>
                  <input
                    type="text"
                    placeholder="Horário de início"
                    value={inputs[`${avlt.id}/availability`]?.start || ''}
                    onChange={(e) =>
                      handleChangeInputs(
                        avlt.id,
                        'start',
                        e.target.value,
                        'availability'
                      )
                    }
                    disabled={checkAllDays}
                  />
                  -
                  <input
                    type="text"
                    placeholder="Horário de término"
                    value={inputs[`${avlt.id}/availability`]?.end || ''}
                    onChange={(e) =>
                      handleChangeInputs(
                        avlt.id,
                        'end',
                        e.target.value,
                        'availability'
                      )
                    }
                    disabled={checkAllDays}
                  />
                </div>
              ))}
          </GroupInput>
        </FormAuth>
      </Center>
    </FormContainer>
  );
}
